/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ElementOrigin, FaultCreationParameters, FaultInfo, ObjectNameInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectFaultClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectFault
   * @summary Получить разломы по проекту.
   * @request GET:/Seismic/project/{projectId}/fault
   * @secure
   */
  projectFaultGetFaultsByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<FaultInfo[], any>({
      path: `/Seismic/project/${projectId}/fault`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectFault
   * @summary Добавить разлом к проекту.
   * @request POST:/Seismic/project/{projectId}/fault
   * @secure
   */
  projectFaultAddFaultToProject = (
    projectId: string,
    query: {
      /**
       * Идентификатор разлома.
       * @format uuid
       */
      faultId: string
      /** Происхождение разлома. */
      elementOrigin?: ElementOrigin
      /** Идентификатор пользователя. */
      userSid?: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/Seismic/project/${projectId}/fault`,
      method: 'POST',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectFault
   * @summary Создание разлома и добавление в проект со ссылкой на исходный разлом(применение ГСМ).
   * @request POST:/Seismic/project/{projectId}/fault/create
   * @secure
   */
  projectFaultCreateProjectFault = (
    projectId: string,
    data: FaultCreationParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/Seismic/project/${projectId}/fault/create`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectFault
   * @summary Добавить пустой разлом к проекту.
   * @request POST:/Seismic/project/{projectId}/fault/empty
   * @secure
   */
  projectFaultAddEmptyFaultToProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<FaultInfo, any>({
      path: `/Seismic/project/${projectId}/fault/empty`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectFault
   * @summary Переименовать разлом.
   * @request PUT:/Seismic/project/{projectId}/fault/rename
   * @secure
   */
  projectFaultRenameFault = (projectId: string, data: ObjectNameInfo, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/Seismic/project/${projectId}/fault/rename`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectFault
   * @summary Удалить существующий проектный разлом.
   * @request DELETE:/Seismic/project/{projectId}/fault/{faultId}
   * @secure
   */
  projectFaultDeleteProjectFault = (
    projectId: string,
    faultId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/Seismic/project/${projectId}/fault/${faultId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
}
